<template>
  <card>
    <b-row align-v="center" slot="header">
      <b-col cols="8">
        <h3 class="mb-0">Edit profile </h3>
      </b-col>
    </b-row>

    <b-form @submit.prevent="updateProfile">
      <h6 class="heading-small text-muted mb-4">My Profile information</h6>
			<b-row>
				<b-col lg="6">
					<base-input type="text" label="Username" placeholder="Username" v-model="auth_user.name">
					</base-input>
				</b-col>
				<b-col lg="6">
					<base-input type="email" label="Email address" placeholder="mike@email.com" v-model="auth_user.email"
						readonly>
					</base-input>
				</b-col>
			</b-row>
			<b-row>
				<b-col lg="6">
					<base-input label="Password" name="password" :type="is_show_password ? 'text' : 'password'" placeholder="Password" v-model="form.password">
						<template #append>
							<a href="javascript:void(0)" @click="is_show_password = !is_show_password">
								<b-icon :icon="!is_show_password ? 'eye' : 'eye-slash'" class="text-muted"></b-icon>
							</a>
						</template>
					</base-input>
				</b-col>
				<b-col lg="6">
					<base-input label="Password Confirmation" name="password_confirmation" :type="is_show_confirm_password ? 'text' : 'password'"
						placeholder="Password Confirmation" v-model="form.password_confirmation">
						<template #append>
							<a href="javascript:void(0)" @click="is_show_confirm_password = !is_show_confirm_password">
								<b-icon :icon="!is_show_confirm_password ? 'eye' : 'eye-slash'" class="text-muted"></b-icon>
							</a>
						</template>
					</base-input>
				</b-col>
			</b-row>
			<h6 class="heading-small text-muted my-3">My Referral Link</h6>
      <b-row>
				<b-col lg="12">
					<div>
						<div class="input-group mb-3">
							<div class="form-control">{{ _gAuth.activeUserReferralLink() }}</div>
							<button class="btn btn-outline-warning" type="button" @click="_gHlp.copyToClipboard(_gAuth.activeUserReferralLink())"><i class="fa fa-copy"></i> Copy</button>
						</div>
					</div>
						
				</b-col>
			</b-row>

      <h5 class="text-danger"> Note : <br><br>
        <i>
          1. Password must be at least 8 characters in length.
        </i>
        <br>
        <i>
          2. Password must contain at least one lowercase letter. [a-z].
        </i>
        <br>
        <i>
          3. Password must contain at least one uppercase letter. [A-Z].
        </i>
        <br>
        <i>
          4. Password must contain at least one number. [0-9].
        </i>
        <br>
        <i>
          5. Password must contain a special character from the list. [@$!%*#?&].
        </i>
        <br>
      </h5>

      <hr class="my-4">
      <div class="text-right">
        <base-button type="primary" @click="updateData()">Update</base-button>
      </div>


    </b-form>
  </card>
</template>
<script>

// import BaseSlider from '@/components/BaseSlider'
import { services, getHeader, getKycHeader } from '@/assets/js/config.js'
import axios from 'axios'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useKycStore } from '@/stores/kycStore'
import { helperFunctionMixin } from '@/assets/js/httpImports.js'

export default
  {
    name: 'edit-my-profile-form',
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
      return {
        form: {
          password: '',
          password_confirmation: '',
        },
        is_show_password: false,
        is_show_confirm_password: false,

      };
    },
    computed: {
      ...mapState(useAuthStore, ['auth_user']),
      ...mapState(useKycStore, ['kyc_user'])
    },
    methods: {
      ...mapActions(useAuthStore, ['fetchUserInfo']),
      updateData() {
        const form = {
          name: this.auth_user.name,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation
        }
        axios.post(services.access_control + 'user/' + this.auth_user.id + '/update-profile', form, { headers: getHeader() })
          .then(res => {
            this.notifySuccess('<b>Profile: Successfully Updated.')
            if (this.checkAppCode('sas')) {
              this.updateKycUserPassword();
            }
            this.form.password = ''
            this.form.password_confirmation = ''
            this.fetchUserInfo()
          })
          .catch(e => {
            this.errorFunction(e)
          });

      },
      updateKycUserPassword() {
        const postData = {
          name: this.auth_user.name,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation,
        }
        axios.post(services.kyc_api + '/setup/user/' + this.kyc_user.id + '/reset_password', postData, { headers: getKycHeader() })
          .then(response => { })
          .catch(error => {
            console.log(error.response.status)
            this.errorFunction(error, "Add User")

          });
      },
    }
  };
</script>
<style></style>
